//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from "axios";
export default {
  name: "Blog",
  head() {
    return {
      title: 'Discover the Latest Trends, Tips, and News in Footwear- Walkway blog',
      meta: [
          {
            hid: 'description',
            name: 'description',
            content: `Stay ahead in the world of footwear with walkway shoes blog. Explore 
            insightful articles on the latest fashion trends, helpful tips, and breaking 
            news in the realm of shoes and fashion.`
          },
          { 
            name: "keywords", 
            content:  "Walkway shoes, fashion trends, helpful tips, footwear"
          },
        ]
    }

  },
  data() {
    return {
      blog_list: [],
      currentPage: 1,
      itemsPerPage: 6,
      totalPages: 0
    };
  },
  methods: {
    async getBlog(page) {
      this.$store.state.list.page_loader = true
      try {
        let response = await axios.get(
          this.$store.state.list.cart_api_url + `/blog/blog-list?page=${page}`
        );
        if (response) {
          this.$store.state.list.page_loader = false;  
          this.blog_list = response.data.data.blogs;
          this.totalPages = Math.ceil(
            response.data.data.count / this.itemsPerPage
          );
        }
      } catch (error) {
        this.$store.state.list.page_loader = false;  
        console.log(error, "Api---error");
      }
    },
    prevPage(a) {
      this.currentPage = this.currentPage - 1;
      this.getBlog(this.currentPage);
      window.scrollTo(0, 0);
    },
    nextPage(b) {
      this.currentPage = this.currentPage + 1;
      this.getBlog(this.currentPage);
      window.scrollTo(0, 0);
    }
  },
   mounted() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
      duration: 1000,
      easing: 'easeInOutQuad' 
    });
  },

  async fetch() {
    this.$store.state.list.plpSeoContent = '';
    await this.getBlog(this.currentPage);
  }
};
